// from general.js
/* global getTrackingLink isTeacherUserPage */


// TODO: rename file as code contained in file doesn't add rf param for teacher

// re-writing url so that if user shares it with friend, it will be tracked properly.
$(window).on('load', function () {
    setTimeout(function () {
        if (isTeacherUserPage()) {
            history.replaceState(null, null, decodeURIComponent(getTrackingLink(location.href, 'page')));
        }
    }, 10);
});
